<template>
  <div :class="{'hideleft':hide === true}" class="page">
    <div class="crumb-container">
      <ol class="breadcrumb">
        <li>
          <a href="javascript:;" class="crumb-home z-font-size-14">财务</a>
        </li>
        <li>
          <a href="javascript:;" class="z-font-size-14">优惠券</a>
        </li>
      </ol>
    </div>
    <div class="page-main z-padding-h-20-precent">
      <div class="panel-heading">
        <div class="panel-title">优惠券</div>
      </div>
      <div class="panel-body clearfix">
        <div class="alert-warn">
          现金券：可用于全站任意消费。
          <br>
          折扣券：不可用于域名类、备案类消费。
          <br>
          每张优惠券仅限一次消费使用，不可重复使用。
        </div>
        <ul class="ub-box coupon-nav z-width-100-precent">
          <li class="coupon-bar z-width-33-precent z-textAlign-center z-lineHeight-25 z-margin-right-15-precent z-curPonit" v-for="(list , couponidx) in couponList" :class="{'active': couponidx === couponIndex}" @click.stop="clickCoupon(couponidx)">
            <a href="javascript:;">{{list.babel}}</a>
          </li>
        </ul>
        <el-table v-show="couponIndex === 0" :data="onuseList" highlight-current-row tooltip-effect="light" v-loading="listLoading" style="width: 100%;">
          <el-table-column prop="yhq_id" label="编号" align="center">
          </el-table-column>
          <el-table-column prop="type" label="类型" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.yhq_type == 1">现金券</span>
              <span v-if="scope.row.yhq_type == 0">折扣券</span>
            </template>
          </el-table-column>
          <el-table-column prop="money_all" label="面值" align="center">
            <template slot-scope="scope">
              {{scope.row.money_all}}￥
            </template>
          </el-table-column>
          <el-table-column prop="money_need" label="所需消费金额" align="center">
            <template slot-scope="scope">
              {{scope.row.money_need}}￥
            </template>
          </el-table-column>
          <el-table-column prop="set_time" label="消费时间" align="center">
          </el-table-column>
          <el-table-column prop="end_time" label="过期时间" align="center">
          </el-table-column>
          <el-table-column prop="remark" label="备注" align="center" max-width="300" show-overflow-tooltip>
          </el-table-column>
        </el-table>
        <el-table v-show="couponIndex === 1" :data="usedList" highlight-current-row tooltip-effect="light" v-loading="listLoading" style="width: 100%;">
          <el-table-column prop="yhq_id" label="编号" align="center">
          </el-table-column>
          <el-table-column prop="type" label="类型" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.yhq_type == 1">现金券</span>
              <span v-if="scope.row.yhq_type == 0">折扣券</span>
            </template>
          </el-table-column>
          <el-table-column prop="money_all" label="面值" align="center">
            <template slot-scope="scope">
              {{scope.row.money_all}}￥
            </template>
          </el-table-column>
          <el-table-column prop="money_need" label="所需消费金额" align="center">
            <template slot-scope="scope">
              {{scope.row.money_need}}￥
            </template>
          </el-table-column>
          <el-table-column prop="set_time" label="消费时间" align="center">
          </el-table-column>
          <el-table-column prop="end_time" label="过期时间" align="center">
          </el-table-column>
          <el-table-column prop="remark" label="备注" align="center" max-width="300" show-overflow-tooltip>
          </el-table-column>
        </el-table>
        <el-table v-show="couponIndex === 2" :data="timeoutList" highlight-current-row tooltip-effect="light" v-loading="listLoading" style="width: 100%;">
          <el-table-column prop="yhq_id" label="编号" align="center">
          </el-table-column>
          <el-table-column prop="type" label="类型" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.yhq_type == 1">现金券</span>
              <span v-if="scope.row.yhq_type == 0">折扣券</span>
            </template>
          </el-table-column>
          <el-table-column prop="money_all" label="面值" align="center">
            <template slot-scope="scope">
              {{scope.row.money_all}}￥
            </template>
          </el-table-column>
          <el-table-column prop="money_need" label="所需消费金额" align="center">
            <template slot-scope="scope">
              {{scope.row.money_need}}￥
            </template>
          </el-table-column>
          <el-table-column prop="set_time" label="消费时间" align="center">
          </el-table-column>
          <el-table-column prop="end_time" label="过期时间" align="center">
          </el-table-column>
          <el-table-column prop="remark" label="备注" align="center" max-width="300" show-overflow-tooltip>
          </el-table-column>
          <span class="table-empty-text" slot="empty">没有找到相关数据</span>
        </el-table>
        <el-pagination v-show="couponIndex === 0" background layout="total, sizes" :page-sizes="[10, 20, 30, 50]" @size-change="handleSizeChangeOn" :page-size="10" :total="onuse.total" class="pull-left">
        </el-pagination>
        <el-pagination v-show="couponIndex === 0" background layout="prev, pager, next" @current-change="handleCurrentChangeOn" :page-size="onuse.count" :total="onuse.total">
        </el-pagination>
        <el-pagination v-show="couponIndex === 1" background layout="total, sizes" :page-sizes="[10, 20, 30, 50]" @size-change="handleSizeChangeUsed" :page-size="10" :total="used.total" class="pull-left">
        </el-pagination>
        <el-pagination v-show="couponIndex === 1" background layout="prev, pager, next" @current-change="handleCurrentChangeUsed" :page-size="used.count" :total="used.total">
        </el-pagination>
        <el-pagination v-show="couponIndex === 2" background layout="total, sizes" :page-sizes="[10, 20, 30, 50]" @size-change="handleSizeChangeOut" :page-size="10" :total="timeout.total" class="pull-left">
        </el-pagination>
        <el-pagination v-show="couponIndex === 2" background layout="prev, pager, next" @current-change="handleCurrentChangeOut" :page-size="timeout.count" :total="timeout.total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
  import caiwuService from 'business/caiwuService.js'
  export default {
    data() {
      return {
        listLoading:false,
        couponIndex: 0,
        couponList: [
          {
            babel: '可用优惠券',
          },
          {
            babel: '已用优惠券',
          },
          {
            babel: '过期优惠券',
          }
        ],
        onuseList:[],
        usedList:[],
        timeoutList:[],
        onuse:{
          count:10,
          total:0,
          page:1,
        },
        used:{
          count:10,
          total:0,
          page:1,
        },
        timeout:{
          count:10,
          total:0,
          page:1,
        },
      }
    },
    props:{
      hide:Boolean
    },
    mounted() {
      this.clickCoupon(0)
    },
    computed: {
      sumPages () {
        return Math.ceil(this.yhqList.length / this.counts)
      },
      crtList () {
        return this.yhqList.slice(this.currentPage * this.counts, (this.currentPage + 1) * this.counts)
      }
    },
    methods:{
      changePageRecord (current) {
        this.currentPage = current
      },
      async clickCoupon(idx) {
        this.couponIndex = idx
        this.$emit('input', this.couponidx)
        if(idx === 0) {
          this.CouponOnuse()
        }
        if(idx === 1) {
          this.CouponUsed()
        }
        if(idx === 2) {
          this.CouponTimeout()
        }
      },
      async CouponOnuse() {
        let data = 'cmd=yhq_list'+
          '&count='+ this.onuse.count +
          '&page='+ this.onuse.page +
          '&yhq_type=onuse'
        this.listLoading = true
        let {vueData, state} = await caiwuService.transformToVue('caiwuInfo','POST',data)
        if(vueData.response == 200 ) {
          this.onuse.total = vueData.data.allcount
          this.onuseList = vueData.data.content
          this.listLoading = false
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      async CouponUsed() {
        let data = 'cmd=yhq_list'+
          '&count='+ this.used.count +
          '&page='+ this.used.page +
          '&yhq_type=used'
        this.listLoading = true
        let {vueData, state} = await caiwuService.transformToVue('caiwuInfo','POST',data)
        if(vueData.response == 200 ) {
          this.used.total = vueData.data.allcount
          this.usedList = vueData.data.content
          this.listLoading = false
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      async CouponTimeout() {
        let data = 'cmd=yhq_list'+
          '&count='+ this.timeout.count +
          '&page='+ this.timeout.page +
          '&yhq_type=timeout'
        this.listLoading = true
        let {vueData, state} = await caiwuService.transformToVue('caiwuInfo','POST',data)
        if(vueData.response == 200 ) {
          this.timeout.total = vueData.data.allcount
          this.timeoutList = vueData.data.content
          this.listLoading = false
        }else {
          this.$toast(vueData.msg,'fail')
        }
      },
      handleCurrentChangeOn(val) {
        this.onuse.page = val;
        this.CouponOnuse()
      },
      handleSizeChangeOn(val) {
        this.onuse.count = val
        this.CouponOnuse()
      },
      handleCurrentChangeUsed(val) {
        this.used.page = val;
        this.CouponUsed()
      },
      handleSizeChangeUsed(val) {
        this.used.count = val
        this.CouponUsed()
      },
      handleCurrentChangeOut(val) {
        this.timeout.page = val;
        this.CouponTimeout()
      },
      handleSizeChangeOut(val) {
        this.timeout.count = val
        this.CouponTimeout()
      },
    }
  }
</script>
<style scoped>
  .page {
    margin-top: 45px;
  }
  .hideleft { margin-left: 80px; }
  .tab-content .tab-pane{
    display: none;
  }
  .tab-content .tab-pane.active{
    display: block;
  }
  .coupon-nav {
    width: 300px;
    margin: 20px 0;
  }
  .coupon-nav .coupon-bar {
    background-color: #f6f7fb;
    border: 1px solid #e5e6e6;
    border-radius: 4px;
  }
  .coupon-nav .coupon-bar.active {
    background-color: #249CFA;
    border: 1px solid #249CFA;
    color: #fff;
  }
  .coupon-nav .coupon-bar.active a{
    color: #fff;
  }
</style>




// WEBPACK FOOTER //
// src/pages/caiwu/caiwu6.vue